import { Easyblocks } from "@easyblocks/core";
import { easyblocksComponents } from "../components";
import { EditorControls } from "../components/EditorControls";
import { useAppStore } from "../state/app-store";
import { useShallow } from "zustand/react/shallow";

export function RenderApp() {
  const {
    documentId,
    renderableDocument,
    renderExternalData,
    renderLoading,
    renderShowChrome,
  } = useAppStore(useShallow((state) => ({
    documentId: state.documentId,
    renderableDocument: state.renderableDocument,
    renderExternalData: state.renderExternalData,
    renderLoading: state.renderLoading,
    renderShowChrome: state.renderShowChrome,
  })));

  const content = !documentId ? (
    <div className="p-4 text-muted">Missing document id.</div>
  ) : renderLoading || !renderableDocument ? (
    <div className="p-4 text-muted">Loading page…</div>
  ) : (
    <Easyblocks
      renderableDocument={renderableDocument}
      externalData={renderExternalData}
      components={easyblocksComponents}
    />
  );

  if (!renderShowChrome) {
    return <div className="easyblocks-render-page">{content}</div>;
  }

  return (
    <div className="d-flex flex-column">
      <EditorControls />
      <main style={{ flex: 1 }}>{content}</main>
    </div>
  );
}
